import React from "react";

const Footer = () => {
  const footerLinks = {
    company: [
      { name: "About Us", href: "/about" },
      { name: "Services", href: "/services" },
      { name: "Careers", href: "/careers" },
      { name: "Contact", href: "/contact" },
    ],
    services: [
      { name: "Web Development", href: "/services" },
      { name: "Mobile Apps", href: "/services" },
      { name: "Cloud Solutions", href: "/services" },
      { name: "AI & ML", href: "/services" },
    ],
    resources: [
      { name: "Documentation", href: "#" },
      { name: "API Reference", href: "#" },
      { name: "Support", href: "#" },
      { name: "Blog", href: "#" },
    ],
    legal: [
      { name: "Privacy Policy", href: "#" },
      { name: "Terms of Service", href: "#" },
      { name: "Cookie Policy", href: "#" },
      { name: "GDPR", href: "#" },
    ],
  };

  const socialLinks = [
    { name: "Twitter", icon: "𝕏", href: "#" },
    { name: "LinkedIn", icon: "in", href: "#" },
    { name: "GitHub", icon: "⚡", href: "#" },
    { name: "Instagram", icon: "📷", href: "#" },
  ];

  return (
    <footer className="bg-gradient-to-br from-[#070b1f] via-[#0a0f2c] to-[#0e143d] border-t border-[#1a1f4a]">
      <div className="container mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          
          {/* Brand */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-bold text-dark-red mb-3">
              Tanvox<span className="text-navy-blue">Tech</span>
            </h3>
            <p className="text-slate-300 leading-relaxed mb-6">
              Building future-ready software solutions that drive business
              growth and digital transformation.
            </p>

            {/* Newsletter */}
            <h4 className="text-white font-semibold mb-3">
              Stay Updated
            </h4>
            <div className="flex flex-col sm:flex-row gap-3 mb-6">
              <input
                type="email"
                placeholder="Enter your email"
                className="flex-1 px-4 py-2 bg-[#11163a] border border-[#1a1f4a] rounded-lg text-white placeholder-slate-400 focus:outline-none focus:border-dark-red"
              />
              <button className="bg-gradient-to-r from-dark-red to-navy-blue px-6 py-2 rounded-lg text-white font-semibold hover:shadow-lg transition-all">
                Subscribe
              </button>
            </div>

            {/* Social */}
            <div className="flex space-x-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  aria-label={social.name}
                  className="w-10 h-10 bg-[#11163a] border border-[#1a1f4a] rounded-full flex items-center justify-center text-dark-red hover:text-navy-blue hover:border-navy-blue transition-all"
                >
                  <span className="text-sm font-bold">
                    {social.icon}
                  </span>
                </a>
              ))}
            </div>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-white font-semibold mb-4">
              Company
            </h4>
            <ul className="space-y-2">
              {footerLinks.company.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-dark-red transition"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-white font-semibold mb-4">
              Services
            </h4>
            <ul className="space-y-2">
              {footerLinks.services.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-dark-red transition"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="text-white font-semibold mb-4">
              Resources
            </h4>
            <ul className="space-y-2">
              {footerLinks.resources.map((link, index) => (
                <li key={index}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-dark-red transition"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-[#1a1f4a] mt-12 pt-6 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">
            © 2024 Tanvox Technologies. All rights reserved.
          </p>

          <div className="flex flex-wrap gap-4">
            {footerLinks.legal.map((link, index) => (
              <a
                key={index}
                href={link.href}
                className="text-slate-400 hover:text-dark-red text-sm transition"
              >
                {link.name}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
